import videojs from 'video.js';

export const getIsTouchDevice = () =>
  !!window.matchMedia('(pointer: coarse)').matches;

export const getIsBrowser = () => typeof window !== 'undefined';

export const getIsMac = () =>
  getIsBrowser() ? navigator.platform.toUpperCase().indexOf('MAC') >= 0 : false;

// https://github.dev/lancedikson/bowser/blob/f09411489ced05811c91cc6670a8e4ca9cbe39a7/src/parser-browsers.js#L663-L678
export const getBrowserVersion = () => {
  if (!getIsBrowser() && !window.navigator.userAgent) return null;

  const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;

  const match = window.navigator.userAgent.match(commonVersionIdentifier);
  return (match && match.length > 0 && match[1]) || '';
};

export const getIosVersion = () => {
  if (!videojs.browser.IS_IOS) return null;

  const match = (navigator?.userAgent || '').match(/OS (\d+)_(\d+)_?(\d+)?/i);

  const [_, majorVer, minorVer, patchVer] = match || [];

  const versionArray = [
    ...(!Number.isNaN(Number.parseInt(majorVer, 10))
      ? [Number.parseInt(majorVer, 10)]
      : []),
    ...(!Number.isNaN(Number.parseInt(minorVer, 10))
      ? [Number.parseInt(minorVer, 10)]
      : []),
    ...(!Number.isNaN(Number.parseInt(patchVer, 10))
      ? [Number.parseInt(patchVer, 10)]
      : []),
  ];

  return versionArray.length > 0
    ? Number.parseFloat(versionArray.join('.'))
    : null;
};
